import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { HiCheck, HiX } from 'react-icons/hi';
import '../assets/css/edit.css';

// Fixed bottom bar for the approver's multi-selection (#9): shows the count
// and the bulk decisions so the user never has to scroll back to the top.
// Same visual pattern as the requester's DownloadSelectionBar.
export default function DecisionSelectionBar({ count = 0, busy = false, onApprove, onReject, onClear }) {
    if (!count) return null;
    return (
        <div className="download-selection-bar" role="toolbar" aria-label="Selected assets">
            <span className="download-selection-count">
                {count} {count === 1 ? 'asset' : 'assets'} selected
            </span>
            <button type="button" className="download-selection-download" disabled={busy} onClick={onApprove}
                title="Approve the selected assets (every format becomes downloadable)">
                <HiCheck size={16} /> Approve Selected
            </button>
            <button type="button" className="download-selection-danger" disabled={busy} onClick={onReject}
                title="Reject the selected assets with one reason">
                <HiX size={16} /> Reject Selected
            </button>
            <button type="button" className="download-selection-clear" onClick={onClear}>
                <IoCloseOutline size={18} /> Clear
            </button>
        </div>
    );
}
